export default [
  {
    path: '/main/banks',
    meta: {
      tag: 'list_bank',
      name: 'Bancos',
      breadcrumb: 'Bancos'
    },
    component: () => import(/* webpackChunkName: "bank-list" */ '@/views/main/settings/test-registers/banks/Index.vue'),
    children: [
      {
        path: '',
        name: 'listbanks',
        meta: {
          tag: 'list_bank',
          menu: 'settings',
          name: 'Bancos'
        },
        component: () => import(/* webpackChunkName: "bank-list" */ '@/views/main/settings/test-registers/banks/List.vue')
      },
      {
        path: '/main/bank/add',
        name: 'addbank',
        meta: {
          tag: 'add_bank',
          menu: 'settings',
          name: 'Adicionar | Banco',
          breadcrumb: 'Adicionar Banco'
        },
        component: () => import(/* webpackChunkName: "bank-add" */ '@/views/main/settings/test-registers/banks/Add.vue')
      },
      {
        path: '/main/bank/:id',
        name: 'editbank',
        meta: {
          tag: 'edit_bank',
          menu: 'settings',
          name: 'Editar | Banco',
          breadcrumb: 'Editar Banco'
        },
        component: () => import(/* webpackChunkName: "bank-edit" */ '@/views/main/settings/test-registers/banks/Edit.vue')
      }
    ]
  },
]
